export default {
    apiUrl: process.env.VUE_APP_SERVER
}